/**
 * Carousel Component
 * @module patterns/components/banners/asset-hero-banner
 */

import Glide from '@glidejs/glide';

import { type App } from '~/app';

import JsController from '../../js-controller';

import { CLASS_NAME } from './constants';

export default (app: App) => {

    const controller = new JsController(app, 'Asset Hero');
    controller.addMountFunction(() => {
        mountAssetHeroBanner(controller);
    })

    return controller.init();
}

export function mountAssetHeroBanner( controller: JsController ) {
    const elements = document.querySelectorAll<HTMLElement>(`.${CLASS_NAME}`);
    let index = 0;
    for (const element of elements) {
        textNewLine(element);
        handleScrollArrowClick(controller, element);
        mountCarousel(controller, element, index);
        index++;
    }
}

// Handle header on new line
const textNewLine = (element: HTMLElement) => {
    const header = element.querySelector('.asset-hero-header');
    if (header) {
        const headerArray = header.innerHTML.split(" ");
        const newHeaderArray: string[] = [];
        for(const headerPart of headerArray) {
            if(headerPart.length < 3 && newHeaderArray.length > 0) {
                newHeaderArray[newHeaderArray.length - 1] = `${newHeaderArray.at(-1)} ${headerPart}`;
            } else {
                newHeaderArray.push(headerPart);
            }
        }
        
        header.innerHTML = newHeaderArray.join("\n");
    }
}

// Handle scroll arrow click
const handleScrollArrowClick = (controller: JsController, element: HTMLElement) => {

    const slideArrows = element.querySelectorAll('.scroll-to-bottom-of-hero');

    if (slideArrows.length > 0) {
        for (const slideArrow of slideArrows) {
            controller.addListener(slideArrow, "click", () => {
                const navigation = document.querySelector<HTMLElement>('.navigation');
                const navigationHeight = navigation ? navigation.clientHeight : 0;
                const scrollToPos = element.getBoundingClientRect().bottom + window.scrollY - navigationHeight;
                window.scrollTo({ top: scrollToPos, behavior: 'smooth' });
            });
        }
    }
}

// Handle scroll arrow click
const mountCarousel = (controller: JsController, element: HTMLElement, carouselIndex: number) => {
    const imageCarousel = element.querySelector('.glide__track');
    if (imageCarousel) {
        const indexClass = `${CLASS_NAME}-${carouselIndex}`;
        element.classList.add(indexClass);
        const glide: Glide = new Glide(`.${indexClass}`, {
            type: 'slider',
            perView: 1,
            startAt: 0,
            gap: 0,
            autoplay: 5000,
            rewind: true,
        })
            .mount();
        controller.addCarouselInstance(glide);
    }
}